import { TPAComponentProps } from '../../types';

export interface ThreeDotsLoaderProps extends TPAComponentProps {
  isStatic?: boolean;
  'aria-hidden'?: React.AriaAttributes['aria-hidden'];
}
